import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  ConsumersList,
  ConsumersListingQueryParameters,
  ConsumersManagementState,
} from "./types";

export const consumersManagementInitialState: ConsumersManagementState = {
  consumersList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },
  consumersListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchKey: "",
  },
};

const consumersManagementSlice = createSlice({
  name: "consumersManagement",
  initialState: consumersManagementInitialState,
  reducers: {
    setConsumersListingData: (
      state: ConsumersManagementState,
      action: PayloadAction<ConsumersList>,
    ) => {
      state.consumersList = { ...action.payload };
    },
    setConsumersListingQueryParameters: (
      state: ConsumersManagementState,
      action: PayloadAction<ConsumersListingQueryParameters>,
    ) => {
      state.consumersListingQueryParameters = { ...action.payload };
    },
  },
});

export const { setConsumersListingData, setConsumersListingQueryParameters } =
  consumersManagementSlice.actions;

export default consumersManagementSlice.reducer;
